<template>
	<div class="ss-content cultura-detial-content">
		<div class="user-info-box">
			<div class="user-avatar">
				<img class="poster-image" :src="userDetail | imgUrl('headImage')" />
			</div>
			<p class="user-name">{{userDetail.username}}</p>
			<!-- <p class="user-other">粉丝：{{userDetail.fansCount}}  |  关注：{{userDetail.followCount}}  |  已发圈子：{{userDetail.culturalCount}}</p> -->
			<!-- <div class="btn-groups">
				<button class="btn-sm" @click="follow(userId, userDetail.followStatus, true)" :class="[userDetail.followStatus === 1 || userDetail.followStatus === 3 ? 'btn-primary-ghost' : 'btn-primary']">
					<span v-if="userDetail.followStatus === 1">取消关注</span>
					<span v-else-if="userDetail.followStatus === 3">互相关注</span>
					<span v-else>关注</span>
				</button>
				<button class="btn-primary btn-sm" @click="publishFlag = true">私信</button>
			</div> -->
			<ss-modal v-model="publishFlag">
				<div class="publish-box">
					<p class="publish-title">私信</p>
					<div class="publish-content">
						<textarea class="publish-textarea" v-model="content"></textarea>
						<div class="publish-btn-group">
							<button class="btn-primary-hollow btn-sm" @click="publishFlag = false">取消</button>
							<button class="btn-primary btn-sm" @click="sendMessage">发送</button>
						</div>
					</div>
				</div>
			</ss-modal>
		</div>
		<div class="ss-container">
			<div class="ss-container__left_xs">
				<ss-circles-list :value="curData_" :finish="finish_" :busy="busy_" />
			</div>
			<!-- <div class="ss-container__right_sm">
				<p class="right-title">TA关注的圈友</p>
				<ul class="follow-list">
					<li class="clearfix" v-for="(item, index) in followData" :key="item.id" v-show="item.followUser">
						<div class="follow-left">
							<img class="poster-image" :src="item.followUser | imgUrl('headImage')" />
						</div>
						<div class="follow-middle">
							<p class="follow-title">{{item.followUser && item.followUser.username}}</p>
							<p class="follow-time">{{item.createTime | time}}</p>
						</div>
						<div class="follow-right" @click="follow(item.followUser.id, item.status)">
							<button v-if="item.status === 1">取消关注</button>
							<button v-else-if="item.status === 3">互相关注</button>
							<button v-else>+ 关注</button>
						</div>
					</li>
				</ul>
			</div> -->
		</div>
	</div>
</template>

<script>
	import ssCirclesList from '@/components/ss-circles-list/ss-circles-list.vue'
	import listMixin from '@/mixins/list.js'
  import {mapState} from "vuex";
	export default {
		mixins: [ listMixin ],
		name: 'culturalDetail',
		components:{
			ssCirclesList
		},
		data() {
			return {
				userDetail: {},
				followData: [],
				content: '',
				userId: '',
				publishFlag: false
			}
		},
    computed: {
      ...mapState({
        userInfo: state => state.user.userInfo
      }),
    },
		created() {
			this.userId = this.$route.params.userId;
			this.culturalMemberInfo();
			this.userFollowPage();
		},
		methods:{
			async sendMessage() {
				if(!this.content) return this.$toast('私信内容不能为空');
				let res = await this.$http('sendMessage', {
					memeberId: [this.userId],
					content: this.content
				})
				if(res.code === 1){
					this.publishFlag = false;
				}
			},
			async follow(id, status, selfFlag = false) {
				let isFollow = status === 1 || status === 3 ? false : true;
				let res = await this.$http(isFollow ? 'follow' : 'cancelFollow', {
					followUserId: id
				});
				console.log(selfFlag);
				res.code ===1 && (selfFlag ? this.culturalMemberInfo() : this.userFollowPage());
			},
			async userFollowPage() {
				let res = await this.$http('userFollowPage', {
					userId: this.userId,
					page: 1,
					size: 10
				});
				if(res.code === 1){
					this.followData = res.data.content || [];
				}
			},
			async culturalMemberInfo() {
				let res = await this.$http('culturalMemberInfo', {
					userId: this.userId
				});
				if(res.code === 1){
					this.userDetail = res.data;
				}
			},
			async resourceUp() {
				let isUp = this.userDetail.followStatus === 0 || this.userDetail.followStatus === 3 ? false : true;
				let res = await this.$http(isUp ? 'resourceCancelUp' : 'resourceUp', {
					contentId: this.userId
				});
				res.code ===1 && this.culturalMemberInfo();
			}
		}
	}
</script>

<style lang="scss">
	.publish-box{
		width: 546px;
		min-height: 400px;
		padding: 30px 60px;
		background-color: #fff;
		.publish-content{
			margin-top: 35px;
			font-size: 18px;
			font-weight: 400;
			color: #484848;
			.publish-btn-group{
				font-size: 0;
				margin-top: 30px;
				text-align: right;
				button{
					display: inline-block;
					width: 126px;
					margin-left: 20px;
					border-radius: 5px;
				}
			}
			.publish-textarea{
				margin-top: 30px;
				height: 163px!important;
			}
		}
		.publish-title{
			text-align: center;
			font-size: 24px;
			font-weight: bold;
			color: #484848;
		}
	}
	.cultura-detial-content{
		padding-bottom: 70px;
		.ss-container__left_xs{
			width: unset;
		}
		.user-info-box{
			border-top: 6px solid #0260FE;
			padding: 30px 40px;
			background: url(~@/assets/img/culturalCircles/user-info-bg.png) center center / 1920px auto no-repeat;
			.btn-groups{
				margin-top: 14px;
				text-align: center;
				font-size: 0;
				button{
					display: inline-block;
					width: 80px;
					border-radius: 5px;
					line-height: 30px;
					height: 30px;
					& + button{
						margin-left: 30px;
					}
				}
			}
			.user-other{
				font-size:18px;
				font-weight:400;
				color: #5B5B5B;
				line-height:18px;
				margin-top: 18px;
				text-align: center;
			}
			.user-name{
				font-size:22px;
				font-weight:400;
				color:rgba(32,42,48,1);
				margin-top: 22px;
				height: 24px;
				line-height: 24px;
				text-align: center;
			}
			.user-avatar{
				img{
					width: 145px;
					height: 145px;
					display: block;
					margin: 0 auto;
					border-radius: 100%;
				}
			}
			& + .ss-container{
				margin-top: 30px;
			}
		}
		.page-more{
			text-align: center;
			span{
				font-size:16px;
				font-weight:400;
				color:rgba(72,72,72,1);
				line-height:30px;
				margin-top: 30px;
				cursor: pointer;
				display: inline-block;
			}
		}
		.ss-container__right_sm{
			border-top: 3px solid #0260FE;
			background-color: #fff;
			padding-bottom: 30px;
			.follow-list{
				li{
					padding: 15px 20px;
					.follow-left{
						width: 50px;
						float: left;
						img{
							display: block;
							width: 50px;
							height: 50px;
							border-radius: 50%;
						}
					}
					.follow-middle{
						padding-left: 10px;
						width: 170px;
						float: left;
					}
					.follow-title{
						font-size: 16px;
						font-weight: 400;
						color: #101010;
						line-height: 18px;
					}
					.follow-time{
						@include ellipsis();
						margin-top: 10px;
						font-size: 16px;
						font-weight: 400;
						color: #B9B9B9;
						line-height: 18px;
					}
					.follow-right{
						margin-top: 10px;
						width: 80px;
						float: right;
						button{
							width: 100%;
							display: block;
							text-align: center;
							line-height: 28px;
							height: 30px;
							background: #FFFFFF;
							border: 1px solid #B7D2FF;
							border-radius: 5px;
							font-size: 14px;
							font-weight: 400;
							color: #035FFE;
						}
					}
				}			
			}
			.right-title{
				font-size: 18px;
				font-weight: 400;
				color: #222229;
				line-height: 40px;
				padding-left: 63px;
			}
		}
	}
</style>
